import debounce from 'lodash.debounce'
import { MouseEvent, useRef, useState } from 'react'

type UseButtonInteractionsProps = {
  onClick?: (event?: MouseEvent) => void
  transitionTime?: number
}

export type ButtonElementProps = (HTMLButtonElement & HTMLAnchorElement) | null

const useButtonInteractions = ({
  onClick,
  transitionTime = 200
}: UseButtonInteractionsProps) => {
  const [clicked, setClicked] = useState(false)

  const buttonRef = useRef<ButtonElementProps>(null)

  const onFocus = () => {
    buttonRef.current?.focus()
  }

  const onBlur = () => {
    buttonRef.current?.blur()
  }

  const handleClick = (event?: MouseEvent) => {
    onClick?.(event)

    setClicked(true)

    debounce(() => {
      setClicked(false)
    }, transitionTime)()
  }

  return {
    clicked,
    buttonRef,
    onBlur,
    onFocus,
    handleClick
  }
}

export default useButtonInteractions
